@if(video) {
  @if(!video.friendlyUrl){
    <h1>NO FRIENDLY URL</h1>
  }
<div class="videoCard mb-4" > 
    <div class="me-md-3 videoThumb minw256">
      <a [routerLink]="video.friendlyUrl != 'index-funds-the-movie' ? ['/videos/' + (video.friendlyUrl?video.friendlyUrl:video.url).toLowerCase()] : ['/indexfundsthemovie/']"  rel="nofollow">
    
        <img loading="lazy" class="img-fluid" width="177" height="100" [src]="video.imageUrl" alt="{{video.title}}" />    
        <div class="new_play text-center">&#9654;</div>
      </a>    
    </div>
    <div class="px-0 h175">
      <a class="videoTitle py-3" routerLink="/videos/{{video.friendlyUrl}}" rel="nofollow">
          <div class="font-14 text-light">{{video.id_other != 6151 ? video.title.replace('Tune Out the Noise - ', '') : video.title}}</div>  
      </a>     
    </div>

    <div id="date" class="pt-1 ps-1 mx-0 d-flex justify-content-between font-12">  
      <div class="fst-normal font-14 color-light-gray">
        {{video.date | date:'M/d/yyyy'}}
      </div>
    </div>
  </div>
  
<!-- <code>
    <pre>
{{video|json}}         
    </pre>
</code> -->
}